"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TemplateMessagingTypes = exports.TemplateFieldSource = exports.TemplateTypes = exports.TemplateFieldTypes = void 0;
/**
 * Represents our template field types.
 * Some types are up for extension in the future, such
 * as the phone and email type that can include extra
 * validations. Other types were purposefully left out,
 * such as a date or time type as we render them as
 * text today. I do not want to add a Date type now,
 * render it as text, and then decide to render it as
 * a Date later when we could have invalid dates in the
 * field. Instead, we can add the new types later, version
 * the template, and properly render based on template version.
 */
var TemplateFieldTypes;
(function (TemplateFieldTypes) {
    TemplateFieldTypes["Text"] = "text";
    TemplateFieldTypes["TokenText"] = "tokentext";
    TemplateFieldTypes["Image"] = "image";
    TemplateFieldTypes["File"] = "file";
    TemplateFieldTypes["UserData"] = "userdata";
    TemplateFieldTypes["Phone"] = "phone";
    TemplateFieldTypes["Email"] = "email";
    TemplateFieldTypes["List"] = "list";
})(TemplateFieldTypes = exports.TemplateFieldTypes || (exports.TemplateFieldTypes = {}));
var TemplateTypes;
(function (TemplateTypes) {
    TemplateTypes["Prospect"] = "prospect";
    TemplateTypes["Resident"] = "resident";
    TemplateTypes["Any"] = "any";
})(TemplateTypes = exports.TemplateTypes || (exports.TemplateTypes = {}));
var TemplateFieldSource;
(function (TemplateFieldSource) {
    TemplateFieldSource["Property"] = "property";
    TemplateFieldSource["Contact"] = "contact";
    TemplateFieldSource["Template"] = "template";
})(TemplateFieldSource = exports.TemplateFieldSource || (exports.TemplateFieldSource = {}));
var TemplateMessagingTypes;
(function (TemplateMessagingTypes) {
    TemplateMessagingTypes["Email"] = "email";
    TemplateMessagingTypes["NurturePage"] = "page";
})(TemplateMessagingTypes = exports.TemplateMessagingTypes || (exports.TemplateMessagingTypes = {}));
